import { render, staticRenderFns } from "./PazienteAccettazioneEdit.vue?vue&type=template&id=03714e14"
import script from "./PazienteAccettazioneEdit.vue?vue&type=script&lang=js"
export * from "./PazienteAccettazioneEdit.vue?vue&type=script&lang=js"
import style0 from "./PazienteAccettazioneEdit.vue?vue&type=style&index=0&id=03714e14&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports